import React, { Component } from 'react';
import { Button, ButtonToolbar, Table, Row, Modal, Form, ControlLabel } from 'react-bootstrap';
import Select from 'react-select';
import { PropTypes } from 'prop-types';
import { LoadingSpinner } from '../../../LoadingSpinner';
import { PaginationBuilder } from '../../../PaginationBuilder';
import { PaginationHelper } from '../../../helpers/PaginationHelper';
import { TableButton } from '../../../TableButton';

export class MapPointStops extends Component {
    static contextTypes = {
        selectApp: PropTypes.func
    }

    constructor(props) {
        super(props);
        this.state = {
            stopSelected: undefined,
            showMapPointStopForm: false,
            currentPage: 1,
            elementsPerPage: 10,
        }
    }

    onChangePage = (page) => {
        this.setState({
            currentPage: page
        });
    }

    onChangeElementsPerPage = (elements) => {
        this.setState({
            elementsPerPage: elements
        });
    }

    handleHide = () => {
        const totalPages = PaginationHelper.getTotalPages(this.props.mapPoint.stops.length, this.state.elementsPerPage);

        this.setState({
            showMapPointStopForm: false,
            currentPage: this.state.currentPage > totalPages ? totalPages : this.state.currentPage,
        });
    }


    renderStopsTable(stops) {
        const stopsToRender = stops.sort((a, b) => a.name !== b.name ? a.name < b.name ? -1 : 1 : 0).slice((this.state.currentPage - 1) * this.state.elementsPerPage, this.state.currentPage * this.state.elementsPerPage);

        return (
            <div className="table-small-screens">
                <Table responsive striped hover >
                    <thead>
                        <tr>
                            <th>Código</th>
                            <th>Nome</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            stopsToRender.sort((a, b) => a.code !== b.code ? a.code < b.code ? -1 : 1 : 0).map((stop, idx) =>
                                <tr key={`stop-${idx}`}>
                                    <td>{`${stop.code}`}</td>
                                    <td>{`${stop.name}`}</td>
                                    <td className="width-1p">
                                        <TableButton onClick={() => this.props.onRemoveSelectedStopValue(stop.id)} className="ps-btn-redTest" icon="icon-error" />
                                    </td>
                                </tr>
                            )
                        }
                    </tbody>
                </Table >
                    <PaginationBuilder currentPage={this.state.currentPage} elementsPerPage={this.state.elementsPerPage} dataLength={stops.length} onChangePage={this.onChangePage}
                onChangeElementsPerPage={this.onChangeElementsPerPage} />
            </div>
        );
    }

    render() {
        const { mapPoint, stops } = this.props;

        const contents = (mapPoint === undefined)
            ? <LoadingSpinner />
            : this.renderStopsTable(mapPoint.stops);

        return (
            <Modal show={this.props.show}>
                <Modal.Header>
                    <Modal.Title>
                        Gerir Paragens Associadas
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div>
                    <Form onSubmit={(e) => { e.preventDefault(); }}>
                        <ControlLabel>Adicionar paragens</ControlLabel>
                        <Select
                            className="custom-multiselect-mapPoint"
                            placeholder="Adicionar uma Paragem"
                            noOptionsMessage={() => "Sem Paragens Selecionáveis"}
                            value={null}
                            isMulti={false}
                                onChange={(e) => {
                                    this.props.onChangeStopValue(e);
                                }}
                            options={
                                stops !== undefined
                                ? stops
                                    .sort((a, b) => a.name !== b.name ? a.name < b.name ? -1 : 1 : 0)
                                    .filter(s => !mapPoint.stops.some(stop => stop.id === s.id) && s.networkEdition === mapPoint.networkEdition)
                                    .map((stop) => {
                                        return {
                                            value: stop.id,
                                            label: `${stop.name} (${stop.code})`
                                        };
                                    })
                                : []
                            }
                        />
                    </Form>
                    </div>
                    <div>
                        <div>
                            {contents}
                        </div>

                        <Row className="btns-small-screens-inside-modal padding-left-15">
                            <ButtonToolbar>
                                <Button onClick={this.props.onHide}>
                                    GUARDAR
                                </Button>
                            </ButtonToolbar>
                        </Row>
                    </div>
                </Modal.Body>
            </Modal>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/datamanager/mapPoints/mapPointStops/MapPointStops.js